import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminPracticeProviderDepartmentOptionsQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminPracticeProviderDepartmentOptionsQueryResultFragment, AdminPracticeProviderDepartmentOptionsQueryParams } from '@docpace/admin-graphql'

const typedAdminPracticeProviderDepartmentOptionsQueryDocument = AdminPracticeProviderDepartmentOptionsQueryDocument as TypedDocumentNode<AdminPracticeProviderDepartmentOptionsQueryResultFragment, Partial<AdminPracticeProviderDepartmentOptionsQueryParams>>

export function useAdminPracticeProviderDepartmentOptionsQuery(opts?: useQuery.Options<AdminPracticeProviderDepartmentOptionsQueryResultFragment, Partial<AdminPracticeProviderDepartmentOptionsQueryParams>>){
    return useQuery(typedAdminPracticeProviderDepartmentOptionsQueryDocument, opts)
}
